/*

Ashraf  10/28/2022  2699758070 moved main tabs to header
Raghu 10/28/2022 2699758070 Dashboard Card stylings
ashraf 10/30/2022 2699758070 conditional tabs render
Ashraf 12/05/2022 2699758070 Fixed header labels
Dilip 12/30/2022 2699758070 renamed trigger maintenance label
*/

import React from 'react';
import EventTacticTabs from './Tabs';
import LandingPage from '../../LandingPage';

function Events() {
  const [value, setValue] = React.useState(0);

  // set Tab Value(2699758070)
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Trigger Maintenance'];


  return (
    <>
      <LandingPage title={'Triggers'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}>
        <div className={`global-field-dash-board`}>
          <div>
            <div>
              <EventTacticTabs value={value}/>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default Events;
